@if (isLoadingCampaign()) {
  <app-loading-component
    [flavorTextOptions]="[
      'Gathering every party note tied to this campaign.',
      'Searching the codex for adventurers bound to this story arc.',
      'Collecting the roster of players who marched through this campaign.'
    ]"
  />
} @else {
  <section class="page-card">
    <app-back-button-component />

    <div class="section-kicker">Campaign Ledger</div>
    <h2 class="section-title">{{ campaignName() || 'Campaign Details' }}</h2>

    @if (loadCampaignError()) {
      <p class="validation-text">{{ loadCampaignError() }}</p>
    } @else if (!sessionRosters().length) {
      <p class="empty-copy">
        @if (selectedSessionId()) {
          The selected session was not found for this campaign.
        } @else {
          No sessions were found for this campaign.
        }
      </p>
    } @else {
      <div class="campaign-summary">
        <div><strong>Campaign:</strong> {{ campaignName() || 'Unknown Campaign' }}</div>
        @if (selectedSessionId()) {
          <div><strong>Selected Session:</strong> {{ sessionRosters()[0].session.name || 'Unnamed Session' }}</div>
        }
        <div><strong>Sessions:</strong> {{ sessionRosters().length }}</div>
        <div><strong>Players Across Sessions:</strong> {{ totalPlayers() }}</div>
      </div>

      <div class="list-grid">
        @for (roster of sessionRosters(); track roster.session.id) {
          <article class="list-card">
            <div class="session-kicker">{{ roster.session.universeName || 'Unknown Universe' }}</div>
            <h3>{{ roster.session.name || 'Unnamed Session' }}</h3>
            <p>{{ roster.session.description || 'No description was provided for this session.' }}</p>

            <div class="campaign-meta">
              <div><strong>Universe:</strong> {{ roster.session.universeName || 'Unknown Universe' }}</div>
              <div><strong>Campaign:</strong> {{ roster.session.campaignName || campaignName() || 'Unknown Campaign' }}</div>
              <div><strong>Master:</strong> {{ getUserName(roster.session.masterId) }}</div>
              <div>
                <strong>Player Count:</strong>
                {{ roster.players.length }} / {{ roster.session.maxPlayers }}
              </div>
            </div>

            <div class="campaign-player-list">
              <div class="section-kicker">Players</div>

              @if (!roster.players.length) {
                <p class="empty-copy">No players have joined this session yet.</p>
              } @else {
                @for (entry of roster.players; track entry.player.id) {
                  <div class="campaign-player-card">
                    <div><strong>Player:</strong> {{ getUserName(entry.player.userId) }}</div>
                    @if (entry.character) {
                      <div><strong>Character:</strong> {{ entry.character.name || 'Unnamed Character' }}</div>
                      <div><strong>Role:</strong> {{ entry.character.role || entry.character.type || 'Unknown Role' }}</div>
                      <a
                        class="secondary-btn"
                        [routerLink]="['/characters', roster.session.id, entry.character.id]"
                      >
                        Open Character
                      </a>
                    } @else {
                      <div><strong>Character:</strong> No character assigned yet.</div>
                    }
                  </div>
                }
              }
            </div>
          </article>
        }
      </div>
    }
  </section>
}
